export default "__VITE_ASSET__CYahhAwo__"